class StickyAtcBar extends HTMLElement {
  connectedCallback() {
    this.sectionId    = this.dataset.sectionId;
    this.addLabel     = this.dataset.addLabel;
    this.soldLabel    = this.dataset.soldLabel;

    this.wrap    = this.querySelector(`#satc-wrap-${this.sectionId}`);
    this.btn     = this.querySelector(`#satc-btn-${this.sectionId}`);
    this.priceEl = this.querySelector(`#satc-price-${this.sectionId}`);

    if (!this.wrap || !this.btn || !this.priceEl) return;

    /* Tag'lerden indirim bilgisi */
    const tags = (this.dataset.tags || '').split('|');
    this.discountPct    = 0;
    this.discountAmount = 0;

    tags.forEach(tag => {
      if (tag.includes('discount-percent')) {
        this.discountPct = parseInt(tag.split(': ')[1]) || 0;
      }
      if (tag.includes('discount-amount')) {
        this.discountAmount = parseInt(tag.split(': ')[1]) || 0;
      }
    });

    this._bindScroll();
    this._bindBtn();
    this._bindVariantChange();
  }

  /* ---------- Yardımcılar ---------- */

  _calcPrice(basePrice) {
    if (this.discountPct > 0) {
      return Math.round(basePrice * (100 - this.discountPct) / 100);
    }
    if (this.discountAmount > 0) {
      return basePrice - this.discountAmount;
    }
    return basePrice;
  }

  _calcPct(base, discounted) {
    if (this.discountPct > 0) return this.discountPct;
    return Math.round((base - discounted) / base * 100);
  }

  _fmt(cents) {
    return (cents / 100).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' TL';
  }

  _renderPrice(basePrice) {
    const discounted = this._calcPrice(basePrice);

    if (discounted < basePrice) {
      const pct = this._calcPct(basePrice, discounted);
      this.priceEl.innerHTML =
        `<span class="satc-price__sale">${this._fmt(discounted)}</span>` +
        `<span class="satc-price__compare">${this._fmt(basePrice)}</span>` +
        `<span class="satc-price__badge">%${pct}</span>`;
    } else {
      this.priceEl.innerHTML =
        `<span class="satc-price__regular">${this._fmt(basePrice)}</span>`;
    }
  }

  /* ---------- Event binding ---------- */

  _bindScroll() {
    window.addEventListener('scroll', () => {
      this.wrap.classList.toggle('is-visible', window.scrollY > 80);
    }, { passive: true });
  }

  _bindBtn() {
    this.btn.addEventListener('click', () => {
      const mainBtn = document.querySelector('[data-add-to-cart]');
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
    });
  }

  _bindVariantChange() {
    document.addEventListener('variant:change', (e) => {
      const v = e.detail?.variant;
      if (!v) return;

      this.btn.disabled    = !v.available;
      this.btn.textContent = v.available ? this.addLabel : this.soldLabel;

      this._renderPrice(v.price);
    });
  }
}

customElements.define('sticky-atc-bar', StickyAtcBar);
